<template>
    <div>
        <b-button variant="default" title="Import Airbnb Property" @click="showModal">
            <font-awesome-icon :icon="['fas', 'download']" />
        </b-button>
        <modal
            :id="modalId"
            title="Import Airbnb Property
"
            @ok="importProperty"
            >This action will overwrite currrent property data. Are you sure you want to proceed?
        </modal>
    </div>
</template>

<script>
import modal from '../generic/modal/modal.vue';
export default {
    components: {
        modal,
    },
    computed: {
        modalId() {
            return 'airbnb-import-modal-id-' + this.params.data.id;
        },
    },
    methods: {
        importProperty() {
            this.params.importProperty && this.params.importProperty(this.params.data);
        },
        showModal() {
            if (this.params.data.lodgix_id) {
                this.$bvModal.show(this.modalId);
            } else {
                this.importProperty();
            }
        },
    },
};
</script>

<style>
</style>